var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.attributes.cellId
    ? _c(
        "div",
        [
          _c("i", { staticClass: "fa fa-asterisk" }),
          _vm._v("\n  " + _vm._s(_vm.$t("kanbanCardCell")) + "\n  "),
          _vm.isBoardNotInSelectedAccount
            ? _c("span", { staticClass: "small text-muted" }, [
                _vm._v(
                  "\n    (" +
                    _vm._s(_vm.$t("workflow.card.cellInDifferentAccount")) +
                    ")\n  "
                )
              ])
            : [
                _vm.store.loading
                  ? _c("Spinner", { attrs: { small: true } })
                  : _c("span", [_vm._v(_vm._s(_vm.cellPath))]),
                _vm._v(" "),
                _c("i", {
                  staticClass: "fa fa-edit c-pointer",
                  on: {
                    click: function($event) {
                      return _vm.$emit("open-system-attributes")
                    }
                  }
                })
              ]
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }